<pbc-filter [config]="ReisekostenabrechnungStatiFilterConfig" [filter]="reisekostenabrechnungStati.filter$ | async" (filterChange)="reisekostenabrechnungStati.filter$.next($event)"></pbc-filter>
